export default __webpack_public_path__ + "e359f4ef044439ec97b7aea16bbb0624.svg";